import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem("token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("token", data.token);
    setUser(data.user);
    return data.user;
  };

  const loginCoordinator = async (email, phone) => {
    const { data } = await api.post("/auth/login-coordinator", { email, phone });
    localStorage.setItem("token", data.token);
    setUser(data.user);
    return data.user;
  };

  const loginMonitor = async (email, phone) => {
    const { data } = await api.post("/auth/login-monitor", { email, phone });
    localStorage.setItem("token", data.token);
    setUser(data.user);
    return data.user;
  };

  const startImpersonation = (token, name, kind) => {
    // نحفظ حسابك الأصلي مرة واحدة فقط حتى يعود زر العودة إليه دائماً
    if (!localStorage.getItem("admin_token")) {
      localStorage.setItem("admin_token", localStorage.getItem("token"));
      localStorage.setItem("impersonating_kind", kind);
    }
    localStorage.setItem("token", token);
    localStorage.setItem("impersonating", name);
    window.location.href = kind === "supervisor" ? "/my-schools" : "/";
  };

  const impersonate = async (schoolId) => {
    const { data } = await api.post(`/admin/impersonate/${schoolId}`);
    startImpersonation(data.token, data.user?.name || "المنسّق", "coordinator");
  };

  const impersonateSupervisor = async (uid) => {
    const { data } = await api.post(`/monitor/impersonate/${uid}`);
    startImpersonation(data.token, data.user?.name || "المشرف", "supervisor");
  };

  const stopImpersonate = () => {
    const adminToken = localStorage.getItem("admin_token");
    const kind = localStorage.getItem("impersonating_kind");
    if (adminToken) localStorage.setItem("token", adminToken);
    localStorage.removeItem("admin_token");
    localStorage.removeItem("impersonating");
    localStorage.removeItem("impersonating_kind");
    window.location.href = kind === "supervisor" ? "/supervisors-oversight" : "/";
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("admin_token");
    localStorage.removeItem("impersonating");
    localStorage.removeItem("impersonating_kind");
    setUser(null);
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, login, loginCoordinator, loginMonitor, logout, impersonate, impersonateSupervisor, stopImpersonate }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
